import { z } from 'zod';

type T = (key: string) => string;

export const ROLE_COLORS = [
  '#6366f1', // Indigo
  '#8b5cf6', // Violet
  '#ec4899', // Pink
  '#ef4444', // Red
  '#f97316', // Orange
  '#eab308', // Yellow
  '#22c55e', // Green
  '#14b8a6', // Teal
  '#3b82f6', // Blue
  '#64748b' // Slate
] as const;

export const createRoleSchema = (t: T) =>
  z.object({
    name_en: z
      .string()
      .min(1, t('roleNameEnRequired'))
      .max(255, t('roleNameMax')),
    name_ar: z
      .string()
      .min(1, t('roleNameArRequired'))
      .max(255, t('roleNameMax')),
    color: z.string().min(1, t('roleColorRequired'))
  });

export const roleSchema = createRoleSchema((key) => {
  const defaults: Record<string, string> = {
    roleNameEnRequired: 'English name is required.',
    roleNameArRequired: 'Arabic name is required.',
    roleNameMax: 'Role name must be at most 255 characters.',
    roleColorRequired: 'Role color is required.'
  };
  return defaults[key] ?? key;
});

export type RoleFormValues = z.infer<typeof roleSchema>;

export const createAssignRoleSchema = (t: T) =>
  z.object({
    user_id: z.string().min(1, t('userRequired'))
  });

export const assignRoleSchema = createAssignRoleSchema((key) => {
  const defaults: Record<string, string> = {
    userRequired: 'Please select a user.'
  };
  return defaults[key] ?? key;
});

export type AssignRoleFormValues = z.infer<typeof assignRoleSchema>;
